module.exports = __webpack_public_path__ + "img/social-studies-1-en.a5fdf751.png";